<template>
  <vue-select
    style="width: 100%"
    :value="value"
    @search="getOptions"
    id="product-brand-id"
    :options="items"
    :label="label"
    class="select-x"
    :placeholder="placeholder"
    @input="changed"
  ></vue-select>
</template>

<script>
import { HTTPAUTH } from "../lib/httplib";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { convertObjToString } from "../lib/helpers";

export default {
  components: {
    VueSelect,
  },
  name: "BrandSelector",
  data () {
    return {
      items: [],
    };
  },
  // props: ["value", "url", "size", "placeholder", "label", "query"],
  props: {
    value: {
      type: Object
    },
    url: {
      type: String
    },
    size: {
      default: 10,
      type: Number
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    query: {
      type: String
    }
  },
  created () {
    this.init("");
  },
  methods: {
    init (q) {
      if (!this.size) {
        this.size = 100;
      }
      var qAdd = "";
      if (this.query) {
        qAdd = "&" + convertObjToString(this.query);
      }
      HTTPAUTH.get(`${this.url}?size=${this.size}&q=${q}${qAdd}`).then(
        (res) => {
          this.items = res.data.data;
        }
      );
    },
    getOptions (search, loading) {
      loading(true);
      this.init(search);
      loading(false);
    },
    changed (evt) {
      this.$emit("input", evt);
    },
  },
};
</script>

<style scoped>
</style>
